export const GITHUB_URL = 'https://github.com/ac3charland/waffle-timer'
export const PORTFOLIO_URL = 'https://www.alexcharland.com/'